export default {
	props: {
      
	},

	data() {

    return {
      darkBackground: true
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/static-page/featured-points-earned/featured-points-earned.js